import { Label } from "@/components/ui/label";

interface PrintInformationProps {
  printNumber: string;
  status: string;
  media?: string;
  printProvider?: string;
  hologramNumber: string;
}

export function PrintInformation({
  printNumber,
  status,
  media,
  printProvider,
  hologramNumber
}: PrintInformationProps) {
  return (
    <div className="space-y-4">
      <div className="border rounded-lg p-4 space-y-3">
        <h3 className="font-semibold text-lg">Print Information</h3>
        
        <div className="flex items-center gap-2">
          <Label className="font-normal min-w-[100px]">Print Number:</Label>
          <span className="font-medium">{printNumber}</span>
        </div>

        <div className="flex items-center gap-2">
          <Label className="font-normal min-w-[100px]">Status:</Label>
          <span className="font-medium">{status}</span>
        </div>

        <div className="flex items-center gap-2">
          <Label className="font-normal min-w-[100px]">Media:</Label>
          <span className="font-medium">{media || "Not specified"}</span>
        </div>

        <div className="flex items-center gap-2">
          <Label className="font-normal min-w-[100px]">Print Provider:</Label>
          <span className="font-medium">{printProvider || "Not specified"}</span>
        </div>

        <div className="flex items-center gap-2">
          <Label className="font-normal min-w-[100px]">Certification:</Label>
          <span className="font-medium">{hologramNumber}</span>
        </div>
      </div>
    </div>
  );
}